import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 announcements_update: { message: "idle" },
};

export const announcements_update_Slice = createSlice({
 name: "announcements_update",
 initialState,
 reducers: {
  success_announcements_update: (state, action) => {
   state.announcements_update = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_announcements_update: (state, action) => {
   state.announcements_update = { status: app_consts.FAIL, message: action.payload };
  },
  reset_announcements_update: (state) => {
   state.announcements_update = { status: app_consts.IDLE };
  },
  loading_announcements_update: (state) => {
   state.announcements_update = { status: app_consts.LOADING };
  },
 }
});

export const { success_announcements_update, fail_announcements_update, reset_announcements_update, loading_announcements_update } = announcements_update_Slice.actions;

export default announcements_update_Slice.reducer;